(function () {
  document.querySelectorAll('[data-store-switcher-dropdown]').forEach(function (root) {
    var toggle = root.querySelector('[data-store-switcher-toggle]');
    var panel = root.querySelector('[data-store-switcher-panel]');
    if (!toggle || !panel) return;

    function open() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      root.setAttribute('data-open', 'true');
      document.addEventListener('click', onDocumentClick);
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      root.removeAttribute('data-open');
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onKeydown);
    }

    function onDocumentClick(event) {
      if (!root.contains(event.target)) close();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        toggle.focus();
      }
    }

    toggle.addEventListener('click', function () {
      if (panel.hidden) {
        open();
      } else {
        close();
      }
    });
  });
})();
